import { render, staticRenderFns } from "./Jogador.vue?vue&type=template&id=4b772782&"
import script from "./Jogador.vue?vue&type=script&lang=js&"
export * from "./Jogador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports